import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { ButtonBaseComponent } from './button-base.component';

@Component({
  selector: 'nibtravel-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends ButtonBaseComponent {
  @HostBinding('class') hostClass = 'btn-host';

  @Input() disabled!: boolean;
  @Input() loader = false;
  @Output() btnClick: EventEmitter<any> = new EventEmitter();
}
